var map = {
	"./app-google-da-DK.svg": 6209,
	"./app-google-de-DE.svg": 10380,
	"./app-google-en-GB.svg": 74550,
	"./app-google-en-US.svg": 74925,
	"./app-google-es-ES.svg": 84982,
	"./app-google-es-MX.svg": 57493,
	"./app-google-fr-FR.svg": 40310,
	"./app-google-it-IT.svg": 27924,
	"./app-google-nb-NO.svg": 90411,
	"./app-google-nl-NL.svg": 21778,
	"./app-google-pl-PL.svg": 34698,
	"./app-google-pt-BR.svg": 50294,
	"./app-google-pt-PT.svg": 85322,
	"./app-google-sv-SE.svg": 65719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38934;